var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group" }, [
    _vm.currentId === null
      ? _c("label", { staticClass: "control-label col-md-3" }, [
          _vm._v(_vm._s(_vm.title))
        ])
      : _vm.currentId !== null
      ? _c("label", { staticClass: "control-label col-md-3" }, [
          _c("a", { attrs: { href: _vm.generateRoute(), target: "_blank" } }, [
            _vm._v(_vm._s(_vm.title) + " "),
            _c("i", { staticClass: "fa fa-link" })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-9 user-input" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.email,
              expression: "email"
            }
          ],
          staticClass: "form-control",
          attrs: {
            placeholder: "Wprowadź adres email ",
            type: "text",
            disabled: _vm.inputDisabled
          },
          domProps: { value: _vm.email },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.email = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.brandId,
                expression: "brandId"
              }
            ],
            staticClass: "form-control",
            attrs: { disabled: _vm.inputDisabled, title: "Marka" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.brandId = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c("option", { domProps: { value: null } }, [_vm._v("Wszystkie")]),
            _vm._v(" "),
            _vm._l(_vm.brands, function(brand) {
              return _c(
                "option",
                { key: brand.id, domProps: { value: brand.id } },
                [
                  _vm._v(
                    "\n                " + _vm._s(brand.name) + "\n            "
                  )
                ]
              )
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2" }, [
        _c(
          "div",
          {
            staticClass: "btn btn-primary btn-block fa fa-search",
            attrs: { disabled: _vm.btnDisabled, title: _vm.btnTitle },
            on: { click: _vm.getUserData }
          },
          [_vm._v("\n           \n      ")]
        )
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "help-block",
          staticStyle: { "padding-left": "15px", color: "#a94442" }
        },
        _vm._l(_vm.errorsToDisplay, function(error, index) {
          return _c("p", { key: index }, [_vm._v(_vm._s(error))])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4ae6f30", { render: render, staticRenderFns: staticRenderFns })
  }
}